import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type7TimeUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type7Time", configService);
    }
}
